import React, { useEffect, useState } from "react";
import styles from "./NewEntry.module.css";

import Textarea from 'rc-textarea';


export const NewEntry = (props) => {

    // props:
    //
    // mediaItem - object containing all book information
    // setNewEntry - state setter to invoke post entry
    // oldEntry - optional, if editing an old entry instead of starting from sctatch
    // setIsAdding - state setter for cancel adding

    // ----------------------------------------------------- STATE AND HOOK

    const [pageTracker, setPageTracker] = useState(); //update current page
    const [titleTracker, setTitleTracker] = useState("");
    const [bodyTracker, setBodyTracker] = useState("");
    const [readingTracker, setReadingTracker] = useState(null); // id of selected reading

    useEffect( () => { 
        // sets page tracker to 0 if progress is null
        if (props.mediaItem && props.mediaItem.progress) {
            setPageTracker(props.mediaItem.progress)
        } else { 
            setPageTracker(0)
        }

        // finds reading numer
        if (props.mediaItem && props.mediaItem.currentReading !== null) {
            // sets to current reading by default
            setReadingTracker(props.mediaItem.currentReading); // current reading

            // for (let i = 0; i < props.mediaItem.readings?.length; i++) {
            //     if (props.mediaItem.readings[i].readingid === props.mediaItem.currentReading) {
            //         // finds reading in book's list of readings
                    
            //     }
            // }

        }
    },[props.mediaItem])

    // ----------------------------------------------------- PRE-RENDER
        function makeDate(date) {
        // formats date in human readable way
        if (date === null || date === "") { // if reading in progress
            return "Present"
        }

        const temp = new Date(date)
        const converted = new Date(temp.getTime() - temp.getTimezoneOffset() * -60000).toLocaleString('en-us', { day: 'numeric', month: 'short', year: 'numeric' });

        return converted;
    }

    const changePage = (event) => {
        // catches changes to page number
        setPageTracker(event.target.value);
    }

    const changeTitle = (event) => {
        // catches changes to title input
        setTitleTracker(event.target.value)
    }

    const changeBody = (event) => {
        // catches changes to body input
        setBodyTracker(event.target.value);
    }

    function changeReading(reading_index) {
        // changes current reading
        setReadingTracker(reading_index);
    }

    const submitEntry = () => {
        // sets new entry to state var of journal

        let entryPostModel = {}

        console.log("POSTING with readingTracker == ", readingTracker)

        if (readingTracker === null) {
            // no reading, thus set to null

           entryPostModel = {
                title: titleTracker,
                body : bodyTracker,
                page : pageTracker,
                readingid : null
            }

        } else {
            // attach to reading

            entryPostModel = {
                title: titleTracker,
                body : bodyTracker,
                page : pageTracker,
                readingid : readingTracker  // BROKEN BROKEN BROKEN BROKEN
            }
        }
        props.setNewEntry(entryPostModel);
    }

    // ----------------------------------------------------- RENDER
    return (
        <section className={styles.container}>
            <div className={styles.inputGroup}>
                <div className={styles.inputTitle}>Title</div>
                <input className={styles.input} key="title input"
                    type="text"
                    placeholder="Title of new journal entry"
                    value={titleTracker}
                    onChange={changeTitle} />
            </div>

            <div className={styles.pageAndReading}>
                <div className={styles.inputGroup}>
                    <div className={styles.inputTitle}>Progress</div>
                    <input className={styles.input} key="page or epsiode input"
                        type="number"
                        value={pageTracker}
                        onChange={changePage}
                        max={props.mediaItem.numpages} />
                </div>
                {
                    props.mediaItem.readings?.length !== 0 ?
                        <div className={styles.inputGroup}>
                            <div className={styles.inputTitle}>Reading</div>
                        
                                <div className={styles.readings_container}>

                                        {props.mediaItem.readings.slice(0).reverse().map((reading, index) =>
                                            <div key={"reading" + index}
                                                onClick={() => changeReading(reading.readingid)}
                                                className={readingTracker === reading.readingid ? styles.reading_selected : styles.reading_unselected}>
                                                <h3>{props.mediaItem.currentReading === reading.readingid ? "Current Reading" : `Reading: ${props.mediaItem.readings?.length - index}` }</h3>
                                                <span>Started on {makeDate(reading.dateStarted)}</span>
                                                {
                                                    reading.dateFinished !== null ?
                                                        <div>Ended on {makeDate(reading.dateFinished)}</div>
                                                        :
                                                        <></>
                                                }
                                            </div>
                                        )
                                        }
                                        <div onClick={() => changeReading(null)}
                                            className={readingTracker === null ? styles.reading_selected : styles.reading_unselected}>
                                            <h3>No Reading</h3>
                                            <span>Do not associate this entry with a reading</span>
                                        </div>

                                </div>
                        </div>
                        :
                        <></>
                }
            </div>
            <div className={styles.inputGroup}>
                <div className={styles.inputTitle}>Body</div>
                <Textarea className={styles.inputBody} key="body input"
                    autoSize={ {minRows: 10} }
                    type="text"
                    placeholder="Body of new journal entry" 
                    value={bodyTracker}
                    onChange={changeBody}/>
            </div>

            <div className={styles.saveAndCancel}>
                <button type="submit" className={styles.cancelButton} onClick={ () => props.setIsAdding(false) }>Cancel</button>
                <button type="submit" className={styles.submitButton} onClick={ () => submitEntry() }>Submit</button>
            </div>
        </section>
    )
}